module.exports = __webpack_public_path__ + "Tracy Zhang-bec69bde.png";